<template>
  <div class="crypto-currency" :class="{'crypto-currency--selected': props.selected}">
    <div class="crypto-currency__icon">
      <img
        :src="getPaybisIconsUrl(`/default/crypto-icons/${props.icon.toUpperCase()}.svg`)"
        :alt="props.label"
        loading="lazy"
        width="24"
        height="24"
      />
    </div>
    <template v-if="assetInfo">
      <div class="crypto-currency__name">
        <div class="crypto-currency__label">
          {{ $t(`asset-names.${assetInfo.id}`) }}
          <div class="crypto-currency__blockchain-name">
            {{ assetInfo.blockchain.name }}
            {{ assetInfo.network?.name }}
          </div>
        </div>
        <div class="crypto-currency__currency-code">{{ assetInfo.currency.code }}</div>
      </div>
    </template>
    <template v-else>
      <div class="crypto-currency__name">
        <div class="crypto-currency__label">{{ props.label }}</div>
        <div class="crypto-currency__currency-code">{{ props.currency }}</div>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { getPaybisIconsUrl } from '@/helpers/cdnHelper';
import { computed } from 'vue';
import store from '@/store/assets/index';

const props = defineProps<{
  currency: string
  selected: boolean
  icon: string
  label: string
}>();

const assetInfo = computed(() => store.getters['assets/getAssetById'](props.currency));
</script>

<style lang="scss" scoped>
@import "@scss-vars";

.crypto-currency {
  display: flex;
  align-items: center;
  padding: 8px;
  font-size: 18px;
  line-height: 24px;
  border-radius: 4px;
  white-space: nowrap;


  &:hover {
    background-color: $grey-04;
    cursor: pointer;
  }

  &--selected {
    background-color: $beige;
  }

  &__icon {
    padding: 8px;
    background-color: $grey-04;
    border-radius: 50%;
    width: 40px;
    height: 40px;
  }

  &__name {
    padding-left: 8px;
    display: flex;
    flex-grow: 1;
    align-content: flex-start;
  }

  &__label {
    flex-grow: 1;
    font-family: $font-bold;
  }

  &__blockchain-name {
    font-size: rem(14);
  }

  &__currency-code, &__blockchain-name {
    color: $grey-30;
    font-family: $font-regular;
  }
}
</style>
